import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

class BlockSliderPosts {
  constructor() {
    this._init();
  }

  _init() {
    new Swiper('.slider-posts__swiper', {
      modules: [Navigation, Pagination],
      direction: 'horizontal',
      slidesPerView: 1,
      spaceBetween: 20,
      grabCursor: false,
      mousewheel: false,
      preventInteractionOnTransition: true,

      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      breakpoints: {
        640: {
          grabCursor: false,
          mousewheel: false

          // autoHeight: false
        }
      }
    });

    const fullSwiper = new Swiper('.swiper-full', {
      modules: [Navigation],
      direction: 'horizontal',
      slidesPerView: 1,
      spaceBetween: 20,
      grabCursor: true,
      mousewheel: true,
      preventInteractionOnTransition: true,
      autoHeight: true,

      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      breakpoints: {
        640: {
          grabCursor: false,
          mousewheel: false
        }
      }
    });

    const voirPlusButtons = document.querySelectorAll('.open-modal');
    const overlay = document.querySelector('.slider-posts__overlay');
    const modal = document.querySelector('.modal') as HTMLElement;
    const closeModalBtn = document.querySelector('.close-modal');

    voirPlusButtons.forEach((btn, index) => {
      btn.addEventListener('click', () => {
        modal.classList.remove('hidden-modal');
        overlay?.classList.remove('hidden-overlay');
        fullSwiper.slideTo(index, 0);
      });
    });

    const closeModal = () => {
      modal.classList.add('hidden-modal');
      overlay?.classList.add('hidden-overlay');
    };

    // Fermer via bouton
    closeModalBtn?.addEventListener('click', closeModal);

    // Fermer via overlay
    overlay?.addEventListener('click', closeModal);

    // Fermer via la touche "esc"
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !modal.classList.contains('hidden-modal')) {
        closeModal();
      }
    });
  }
}

export const blockSliderPosts = new BlockSliderPosts();
